import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";

const FlipCountdown = () => {
  return (
    <Flex
      justify="center"
      // align="center"
      my="8"
      rounded={"md"}
      height="max-content"
      px={4}
      flexWrap="wrap"
    >
      <Box>
        <Text
          px={{ base: 1, md: 4 }}
          py={{ base: 1, md: 2 }}
          textAlign={"center"}
          fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
          bg="brand.500"
          color="white"
          fontWeight="semibold"
        >
          05
        </Text>
        <Text align="center" pt={4} color="blackAlpha.700" fontSize={{base:"10px",sm:"16px"}}>
          Days
        </Text>
      </Box>
      <Text
        px={{ base: 1, md: 4 }}
        py={{ base: 1, md: 2 }}
        textAlign={"center"}
        fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
        color="brand.500"
        fontWeight="semibold"
      >
        :
      </Text>
      <Box>
        <Text
          px={{ base: 1, md: 4 }}
          py={{ base: 1, md: 2 }}
          textAlign={"center"}
          fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
          bg="brand.500"
          color="white"
          fontWeight="semibold"
        >
          15
        </Text>
        <Text align="center" pt={4} color="blackAlpha.700" fontSize={{base:"10px",sm:"16px"}}>
          Hours
        </Text>
      </Box>
      <Text
        px={{ base: 1, md: 4 }}
        py={{ base: 1, md: 2 }}
        textAlign={"center"}
        fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
        color="brand.500"
        fontWeight="semibold"
      >
        :
      </Text>
      <Box>
        <Text
          px={{ base: 1, md: 4 }}
          py={{ base: 1, md: 2 }}
          textAlign={"center"}
          fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
          bg="brand.500"
          color="white"
          fontWeight="semibold"
        >
          38
        </Text>
        <Text align="center" pt={4} color="blackAlpha.700" fontSize={{base:"10px",sm:"16px"}}>
          Minutes
        </Text>
      </Box>
      <Text
        px={{ base: 1, md: 4 }}
        py={{ base: 1, md: 2 }}
        textAlign={"center"}
        fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
        color="brand.500"
        fontWeight="semibold"
      >
        :
      </Text>
      <Box>
        <Text
          px={{ base: 1, md: 4 }}
          py={{ base: 1, md: 2 }}
          textAlign={"center"}
          fontSize={{ base: "22px", md: "40px", "2xl": "48px" }}
          bg="brand.500"
          color="white"
          fontWeight="semibold"
        >
          55
        </Text>
        <Text align="center" pt={4} color="blackAlpha.700" fontSize={{base:"10px",sm:"16px"}}>
          Seconds
        </Text>
      </Box>
    </Flex>
  );
};

export default FlipCountdown;
